import { FieldDescriptor } from './Helper/Descriptor';

export default function simpleFormat(p) {
    const result = [];
    const hasMoreThanOneField = p.descriptor.fields.filter(f => !f.options || !f.options.hideInInspector).length > 1;

    for (let field of p.descriptor.fields) {
        if (field.isMap) {
            const mapValue = p[field.name];
            if (Object.keys(mapValue).length > 0) {
                if (hasMoreThanOneField) {
                    result.push(field.name);
                }
                for (let key in mapValue) {
                    result.push(key);
                    result.push(simpleFormat(mapValue[key]));
                }
            }
            continue;
        } else if (field.isRepeated) {
            const values = p[field.name];
            if (values.length > 0) {
                if (hasMoreThanOneField) {
                    result.push(field.name);
                }
                for (let value of values) {
                    if (field.protoType === FieldDescriptor.TYPE_MESSAGE) {
                        result.push(simpleFormat(value));
                    } else {
                        result.push(value);
                    }
                }
            }
            continue;
        } else if (field.oneofIndex !== undefined) {
            const oneof = p.descriptor.oneofs[field.oneofIndex];
            if (p[oneof.name + 'Case'] !== field.number) {
                continue;
            }
        } else {
            if (!p['has' + field.Name]) {
                continue;
            }
        }
        if (field.protoType === FieldDescriptor.TYPE_MESSAGE) {
            if (hasMoreThanOneField) {
                result.push(field.name);
            }
            result.push(simpleFormat(p[field.name]));
        } else {
            if (hasMoreThanOneField) {
                result.push(field.name);
            }
            result.push(p[field.name]);
        }
    }
    return result.filter(i => i).join('.');
}
